import { Injectable } from '@angular/core';
import { NetworkService } from 'src/app/common/network.service';

@Injectable({
  providedIn: 'root'
})
export class OrganizationService {

  constructor(private networkservice:NetworkService) { }

  uploadImage(image: any) {
    const formData = new FormData();

    formData.append("image", image, 'image.jpg');
    return this.networkservice.uploadImages("api/s3upload/", formData, null, "bearer");
  }

  getOrganizationsApi(query:any) {
    return this.networkservice.get("api/organization?"+ query, null, null, "bearer");
  }
  getProviderApi(query:any) {
    return this.networkservice.get("api/provider?"+ query, null, null, "bearer");
  }
  saveOrganizationApi(body: any) {
    return this.networkservice.post("api/organization", body, null, "bearer");
  }
  editOrganizationApi(body: any) {
    return this.networkservice.put("api/organization", body, null, "bearer");
  }
  deleteOrganizationApi(body: any) {
    return this.networkservice.delete("api/organization/"+ body, null, "bearer");
  }
  getProfileInfo(query:any) {
    return this.networkservice.get("api/auditLog/profileAccess?"+ query, null, null, "bearer");
  }
  getBarChart(query:any){
    return this.networkservice.get("api/auditLog/profileAccess/Dashboard?"+query, null, null,'bearer');
  }
  getProfileAccessLogs(query:any){
    return this.networkservice.get("api/auditLog/profileAccess?"+query, null, null,'bearer');
  }
  getProfilePatient(query:any){
    return this.networkservice.get("api/auditLog/profileAccess/unique?"+query, null, null,'bearer');
  }
  
  
}
